import dynamic from 'next/dynamic';
import NextLink from 'next/link';
import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import Text from 'shopper/components/Text';

import Anchor from 'components/Anchor';
import UserAvatar from 'components/UserAvatar';

import { getTimeTo } from 'lib/date';
import { toUserProfileLink } from 'lib/links';
import placeholder from 'lib/placeholder';
import { isGenieUser, toUsernameWithAtSign } from 'lib/user';

import Dropdown from './Dropdown';

const Edited = dynamic(() => import('./Edited'), { ssr: false });

const CommentItemHeader = ({
  canBeRecommendedAsReview,
  commentDate,
  commentFixed,
  commentId,
  isContentBlocked,
  isEdited,
  isReview,
  userId,
  userName,
  userPhoto,
  userTypeName,
  userUsername,
  onEditCommentClick,
}) => (
  <div className="relative mb-2 flex justify-between">
    <div className="w-full">
      {userName && (
        <div className="flex flex-row items-center">
          <div className="relative mr-2">
            {userName ? (
              <NextLink
                href={toUserProfileLink(userUsername)}
                prefetch={false}
                passHref
              >
                <Anchor
                  className={twJoin(
                    isGenieUser(userId) && 'pointer-events-none'
                  )}
                >
                  <UserAvatar
                    size="size6"
                    userId={userId}
                    userName={userName}
                    userPhoto={userPhoto}
                    userTypeName={userTypeName}
                  />
                </Anchor>
              </NextLink>
            ) : (
              <UserAvatar
                description={placeholder('errors.userNotFound')}
                size="size6"
                userId={userId}
              />
            )}
          </div>
          <div className="flex w-full items-center justify-between lg:flex-row lg:items-center lg:gap-x-2">
            <Text
              className="w-32 overflow-hidden text-ellipsis md:w-unset"
              size="size3"
              bold
            >
              {userName
                ? toUsernameWithAtSign(userUsername)
                : placeholder('errors.userNotFound')}
            </Text>
            <div className="flex items-center md:gap-4">
              <Text size="size3">{getTimeTo(commentDate)}</Text>
              {!isContentBlocked && (
                <Dropdown
                  canBeRecommendedAsReview={canBeRecommendedAsReview}
                  commentFixed={commentFixed}
                  commentId={commentId}
                  isEdited={isEdited}
                  isReview={isReview}
                  userId={userId}
                  onEditCommentClick={onEditCommentClick}
                />
              )}
            </div>
          </div>
        </div>
      )}
      {isEdited && <Edited className="mt-2" />}
    </div>
  </div>
);

CommentItemHeader.propTypes = {
  canBeRecommendedAsReview: PropTypes.bool.isRequired,
  commentDate: PropTypes.string.isRequired,
  commentFixed: PropTypes.bool.isRequired,
  commentId: PropTypes.number.isRequired,
  isContentBlocked: PropTypes.bool.isRequired,
  isEdited: PropTypes.bool.isRequired,
  isReview: PropTypes.bool.isRequired,
  userId: PropTypes.number.isRequired,
  userUsername: PropTypes.string.isRequired,
  userName: PropTypes.string.isRequired,
  userPhoto: PropTypes.string.isRequired,
  userTypeName: PropTypes.string.isRequired,
  onEditCommentClick: PropTypes.func.isRequired,
};

export default CommentItemHeader;
